import React, { Component } from 'react';
import { ORGANIZATION } from 'marketing/metadata';

export default class ReviewsAggMetadata extends Component {
  componentDidMount() {
    this.props.fetchReviewStatsIfNeeded();
  }

  render() {
    const { itemName, itemDescription, stats } = this.props;
    const scriptTag = `
<script type="application/ld+json">
  {
    "@context": "http://schema.org/",
    "@type": "AggregateRating",
    "itemReviewed": {
      "@type": "Product",
      "name": "${itemName || "Logo design, graphic design, web design, product design and company naming"}",
      "description": "${itemDescription || "The #1 marketplace for logo design, web design, graphic design and company names. 60,000+ happy clients! Work you'll love, guaranteed."}",
      "brand": {
        ${ORGANIZATION}
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "${stats.avg}",
        "reviewCount": ${stats.count}
      }
    },
    "ratingValue": "${stats.avg}",
    "reviewCount": ${stats.count}
  };
</script>
`;

    if (stats.avg === undefined) {
      return null;
    }

    return <span dangerouslySetInnerHTML={{ __html: scriptTag }} />;
  }
}
